
const DashboardHome = () => {


  return (
    <div className="flex-grow ">
      {/* <ToastContainer /> */}
      <div className="mx-auto mt-2 " >
        <div className="flex flex-col space-y-4 rounded-lg p-12">
          <div className="grid grid-cols-4 gap-4 ">
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardHome;
